import { formatMessage } from "lib/globalize-util";
import {
    WHITEBOARD_BOARD_FETCH,
    WHITEBOARD_BOARDS_CLEAR,
    WHITEBOARD_BOARDS_CREATE,
    WHITEBOARD_BOARDS_CREATE_COMPLETED,
    WHITEBOARD_BOARDS_DELETE,
    WHITEBOARD_BOARDS_DELETE_COMPLETED,
    WHITEBOARD_BOARDS_FETCH,
    WHITEBOARD_BOARDS_FETCH_COMPLETED,
    WHITEBOARD_BOARDS_DUPLICATE,
} from "constants/action-types";
import { EventTypes } from "redux-segment";
// import { createBoardQuery, deleteBoardQuery, fetchBoardsQuery } from "queries/whiteboard";

export const fetchById = (id, userId) => ({
    payload: {
        id,
        userId,
    },
    type: WHITEBOARD_BOARD_FETCH,
});

export const fetchBoards = (userId, options?) => ({
    payload: { userId, options },
    type: WHITEBOARD_BOARDS_FETCH,
});

export const fetchBoardsSuccess = (payload) => ({
    payload,
    type: WHITEBOARD_BOARDS_FETCH_COMPLETED,
});

export const fetchBoardsError = (payload, error) => ({
    error,
    payload,
    type: WHITEBOARD_BOARDS_FETCH_COMPLETED,
});

export const createBoard = (
    name = formatMessage("Untitled Whiteboard"),
    merchant: {
        merchantId?: string;
        parentId?: string;
        retry?: number;
        callback?: (whiteboardId: string, failureCount?: number) => void;
    } = {},
) => ({
    meta: {
        analytics: EventTypes.track,
    },
    payload: { name, merchant },
    type: WHITEBOARD_BOARDS_CREATE,
});

export const createBoardSuccess = (payload) => ({
    payload,
    type: WHITEBOARD_BOARDS_CREATE_COMPLETED,
});

export const createBoardError = (payload, error) => ({
    error,
    payload,
    type: WHITEBOARD_BOARDS_CREATE_COMPLETED,
});

export const deleteBoard = (boardId) => ({
    meta: {
        analytics: EventTypes.track,
    },
    payload: { boardId },
    type: WHITEBOARD_BOARDS_DELETE,
});

export const deleteBoardSuccess = (payload) => ({
    payload,
    type: WHITEBOARD_BOARDS_DELETE_COMPLETED,
});

export const deleteBoardError = (payload, error) => ({
    error,
    payload,
    type: WHITEBOARD_BOARDS_DELETE_COMPLETED,
});

export const duplicateBoard = (boardId, boardName) => ({
    meta: {
        analytics: EventTypes.track,
    },
    payload: { boardId, boardName },
    type: WHITEBOARD_BOARDS_DUPLICATE,
});

export const clearBoards = () => ({ type: WHITEBOARD_BOARDS_CLEAR });
